import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import { DigitalMapBusRoute } from 'models/digitalMap';

const getLatLng = (latLng: { lat: number; lng: number }) => {
  return new google.maps.LatLng(latLng.lat, latLng.lng);
};

interface Props {
  route: DigitalMapBusRoute;
}

export const GPSBusOverlay: React.FC<Props> = ({ route }) => {
  return (
    <>
      {route.gps_devices
        .filter((bus) => bus.is_active)
        .map((bus, index) => (
          <OverlayView
            key={`${route.id}-${index}`}
            position={getLatLng({ lat: bus.latitude, lng: bus.longitude })}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div
              style={{
                position: 'absolute',
                // transform: `translate(-50%, -50%) rotate(${(bus.heading || 0) + 90}deg)`,
                transform: `translate(-50%, -50%)`,
                backgroundColor: '#fff',
                borderRadius: '50%',
                width: '58px',
                height: '58px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src="/static/images/map/bus.svg" />
            </div>
          </OverlayView>
        ))}
    </>
  );
};
